import styled from 'styled-components'

const StyledListSection = styled.section`
  max-width: 1004px;
  min-width: 375px;
  margin: 0 auto;
  padding: 0 32px;
  @media only screen and (max-width: 376px) {
    padding: 0 24px;
  }
`

export default StyledListSection
